import { Campaign } from '@mui/icons-material';
import SwapHorizontalCircleOutlinedIcon from '@mui/icons-material/SwapHorizontalCircleOutlined';
import { Chip, Grid, Tooltip, Typography } from '@mui/material';
import { Invoice } from 'lib/api/paymentLink/types';
import CustomButton from 'lib/designSystem/Button';
import { formatDate, formatMoney } from 'lib/functions/utils';
import React from 'react';

interface InvoiceRowProps {
  handleClickFromInvoice: (invoiceId: string) => void;
  invoice: Invoice;
}

const InvoiceRow: React.FC<InvoiceRowProps> = (props) => {
  const { invoice, handleClickFromInvoice } = props;
  const { id, folio, amount, issuedDate, type, business } = invoice;
  const paid = invoice.isPaid;
  const companyOwner = type === 'cession' ? invoice.newBusiness : business.name;
  const oldBusiness = business.name;
  return (
    <Grid
      container
      style={{
        border: 'solid 0.1px',
        borderColor: '#FFFF',
        padding: '16px',
        borderRadius: '5px',
        backgroundColor: '#FFFF',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px',
        marginTop: '20px',
        alignItems: 'center',
      }}
    >
      <Grid item xs={2}>
        <div>
          <Typography variant="body1"> #{folio}</Typography>
        </div>
      </Grid>
      <Grid item xs={2}>
        <div>
          {!paid && (
            <Chip variant="outlined" label="Pendiente de pago" color="info" />
          )}
          {paid && <Chip variant="outlined" label="Pagada" color="success" />}
        </div>
      </Grid>
      <Grid item xs={2}>
        <div>
          <Typography variant="body1">
            {formatDate(new Date(issuedDate))}
          </Typography>
        </div>
      </Grid>
      <Grid item xs={2}>
        <div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            {type === 'cession' && (
              <Tooltip
                title={`La factura ha sido cedida por ${oldBusiness} a ${companyOwner}`}
                arrow
              >
                <SwapHorizontalCircleOutlinedIcon
                  style={{ marginRight: '5px' }}
                />
              </Tooltip>
            )}
            <Typography variant="body1">
              <span>{companyOwner} </span>
            </Typography>
          </div>
        </div>
      </Grid>
      <Grid item xs={2}>
        <div>
          <Typography variant="body1"> {formatMoney(amount)} </Typography>
        </div>
      </Grid>
      <Grid item xs={2}>
        <div>
          <CustomButton
            startIcon={<Campaign />}
            color="primary"
            variant="contained"
            disabled={paid}
            onClick={() => handleClickFromInvoice(id)}
          >
            Informar pago
          </CustomButton>
        </div>
      </Grid>
    </Grid>
  );
};

export default InvoiceRow;
